import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { SupportTicketResponse } from "../../aiTickets.types";
import { ApiRoutesSupportTickets } from "../../constants/enums";

export const requestGetTicket = async (
  ticketId: string,
): Promise<SupportTicketResponse> => {
  return await instance.get(
    buildUrl(ApiRoutesSupportTickets.Tickets, ticketId),
  );
};
